/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Exclude_DrawnInputs */



/**
* | output |
* | --- |
* | "Exclude previous winners" |
*
* @param {Raffle_Exclude_DrawnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_exclude_drawn = /** @type {((inputs?: Raffle_Exclude_DrawnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Exclude_DrawnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exclure les gagnants précédents")
	if (locale === "es") return /** @type {LocalizedString} */ ("Excluir ganadores anteriores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir vencedores anteriores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Escludi vincitori precedenti")
	return /** @type {LocalizedString} */ ("Exclude previous winners")
});